<ng-progress [speed]="400" [spinner]="true" [color]="progressColor" #progress>
</ng-progress>
<section class="app">
    <mmp5-f-cms-navbar
    [show]="showAppBar"
    [navbar_items]="navbar_items"
    [mediaUrl]="mediaUrl"
    [loggedUser]="user"
    [colors]="colors"
    [selectedColorId]="colorSelected"
    (selectedColor)="setColor($event)"
    (signout)="logout()"
    [contentMenuStatus]="showCM"
    (showContentMenu)="showCM = $event"
    [hasPermissionToConfig]="userHasConfigPermission"
    [unreadNotifys]="nots"
    [token]="token"
    [chatBadge]="chatNots"
    [showHomepagesOnNavbar]="showHomepagesOnNavbar"
    >
</mmp5-f-cms-navbar>
  <app-content-menu [selectedPage]="selectedPageId" *ngIf="showAppBar" (closed)="showCM = $event"
    [contentMenu]="showCM"></app-content-menu>
  <router-outlet></router-outlet>
</section>
<mm-notify-dialog-management></mm-notify-dialog-management>
<p-toast position="top-right" [baseZIndex]="'9999'" [style]="{'margin-top': '5.3rem','z-index':'1003'}"></p-toast>
<app-scroll-to-top></app-scroll-to-top>
<script type="text/javascript" src="https://www.gstatic.com/charts/loader.js"></script>
